import { fraunces } from '../../Landing/fonts';
import {
  Accent,
  ArrowIcon,
  CtaButton,
  Eyebrow,
  INK,
  MUTED,
  Reveal,
  Stamp,
} from '../../Landing/ui';

export default function AiFinalCta({ user, onJoin }) {
  return (
    <section className="tw-pb-24">
      <div className="tw-mx-auto tw-max-w-4xl tw-px-4 sm:tw-px-6">
        <Reveal>
          <div className="tw-relative tw-rounded-2xl tw-border tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] [border-width:1.5px] tw-bg-[#FFFDF6] dark:tw-bg-[#15231E] tw-px-7 tw-py-12 tw-text-center tw-shadow-[0_30px_60px_-30px_rgba(29,45,40,0.45)] sm:tw-px-12">
            <Stamp className="tw-absolute -tw-left-4 -tw-top-7 tw-h-20 tw-w-20 -tw-rotate-12 tw-text-primary-700/70 dark:tw-text-primary-300/70" />
            <Eyebrow className="tw-mb-3">Final call</Eyebrow>
            <h2
              className={`${fraunces.className} ${INK} tw-m-0 tw-text-3xl tw-font-semibold tw-leading-tight tw-tracking-tight sm:tw-text-4xl`}
            >
              Your next article is already
              <br />
              on your <Accent>camera roll</Accent>.
            </h2>
            <p
              className={`${MUTED} tw-mx-auto tw-mb-0 tw-mt-4 tw-max-w-md tw-text-[15px] tw-leading-relaxed`}
            >
              Pick fifteen photos from your last trip and tell it what happened.
              That&apos;s the whole job. The writing is the easy part.
            </p>
            <div className="tw-mt-8 tw-flex tw-justify-center">
              {user ? (
                <CtaButton href="/dashboard/aiblogger">
                  Start with your photos
                  <ArrowIcon />
                </CtaButton>
              ) : (
                <CtaButton onClick={onJoin}>
                  Start with your photos
                  <ArrowIcon />
                </CtaButton>
              )}
            </div>
            <p
              className={`${MUTED} tw-mb-0 tw-mt-5 tw-font-mono tw-text-xs tw-tracking-wide`}
            >
              From $19/year · AI credits included every month · Cancel anytime
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
